module.exports = __webpack_public_path__ + "static/calm-6b605478f3a81f8fd20127def241a2c8.png";